const escapeHtml = (value: string): string => value
	.replace(/&/g, '&amp;')
	.replace(/</g, '&lt;')
	.replace(/>/g, '&gt;')
	.replace(/"/g, '&quot;')
	.replace(/'/g, '&#039;');

const safeUrl = (value: string): string => {
	const candidate = value.trim();
	if (/^\/(?!\/)/.test(candidate)) return candidate;
	try {
		const url = new URL(candidate);
		return ['http:', 'https:'].includes(url.protocol) ? candidate : '';
	} catch {
		return '';
	}
};

const attributes = (value: string): Record<string, string> => {
	const result: Record<string, string> = {};
	const pattern = /([a-z0-9_-]+)\s*=\s*(["'])(.*?)\2/gi;
	let match: RegExpExecArray | null;
	while ((match = pattern.exec(value))) result[match[1].toLowerCase()] = match[3];
	return result;
};

const shortcodeHtml = (type: string, rawAttributes: string): string => {
	const values = attributes(rawAttributes);
	const url = safeUrl(values.url ?? '');
	if (!url) return '';
	const escapedUrl = escapeHtml(url);
	if (type === 'link') {
		const label = escapeHtml(values.label?.trim() || url);
		return `<a href="${escapedUrl}" target="_blank" rel="noopener">${label}</a>`;
	}
	if (type === 'image') {
		return `<img class="new-trivia-instruction-image" src="${escapedUrl}" alt="">`;
	}
	if (type === 'youtube' || type === 'vimeo') {
		return `<div class="new-trivia-instruction-video"><iframe src="${escapedUrl}" title="Embedded video" loading="lazy" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>`;
	}
	return '';
};

const instructionLineHtml = (value: string): string => {
	if (!value.trim()) return '<div class="new-trivia-instruction-spacer" aria-hidden="true"></div>';
	return '<div class="new-trivia-instruction-line">'
		+ '<span class="fa-solid fa-check new-trivia-instruction-check" aria-hidden="true"></span>'
		+ `<div class="new-trivia-instruction-line-content">${value}</div>`
		+ '</div>';
};

export const renderRichText = (value: string): string => {
	if (!value) return '';
	const tokens: string[] = [];
	const hold = (html: string): string => {
		const token = `\uE000${tokens.length}\uE001`;
		tokens.push(html);
		return token;
	};

	let output = value.replace(/<\/?(?:p|br|strong|em|u|ul|ol|li)\s*\/?\s*>/gi, (tag) => hold(tag));
	output = output.replace(/\[(link|image|youtube|vimeo)\s+([^\]]+)\]/gi, (match, type: string, rawAttributes: string) => {
		const html = shortcodeHtml(type.toLowerCase(), rawAttributes);
		return html ? hold(html) : match;
	});
	output = escapeHtml(output).replace(/\r\n?/g, '\n').replace(/\n/g, '<br>');
	tokens.forEach((html, index) => {
		output = output.replaceAll(`\uE000${index}\uE001`, html);
	});
	return output;
};

export const renderInstructions = (value: string): string => {
	const output = renderRichText(value);
	return output ? output.split(/<br\s*\/?\s*>/i).map(instructionLineHtml).join('') : '';
};
